module.exports = [{"ruleKey":"A","colour":"#38ffd2","operation":"root","successors":{"kind":"specific","rules":[null,"B",null,"B",null,null]},"scale":0.4},{"ruleKey":"B","colour":"#4488ee","successors":{"kind":"specific","rules":["C",null,null,null,null,null]},"operation":"jump","scale":1},{"ruleKey":"C","colour":"#44eec7","successors":{"kind":"specific","rules":["B","B",null,"B",null,null]},"operation":"truncatedPyramid","scale":1}]


//////////////////
// WEBPACK FOOTER
// ./src/data/examples/butterfly.json
// module id = 100
// module chunks = 35783957827783 213497200229540